import React, { useMemo } from 'react';
import { MarketNftStatuses } from '../Interfaces';
import MarketPageDescBlock, {
  MarketDescBlockValue
} from '../description/block';
import usePromo, { calculateNewPrice } from '../promoCode/Context';

interface Props {
  status: MarketNftStatuses;
  price: number | string;
  className?: string;
}

type Wording = {
  title: string;
  value: MarketDescBlockValue;
};

const MarketPageActionHint = ({ status, price, className }: Props) => {
  const { appliedCode } = usePromo();

  const wording = useMemo<Wording>(() => {
    switch (status) {
      case MarketNftStatuses.UNAVAILABLE:
        return { title: 'Status', value: 'Unavailable' };
      case MarketNftStatuses.MINTED:
        return { title: 'Status', value: 'In your Gang' };
      case MarketNftStatuses.FAILED:
        return { title: 'Status', value: 'Mint Failed' };
      case MarketNftStatuses.PENDING:
        return { title: 'Status', value: 'Mint Transaction Pending' };
      //available
      default: {
        if (typeof price === 'string') {
          return { title: 'Price', value: price };
        }
        if (!appliedCode) {
          return {
            title: 'Price',
            value: `${price} ${process.env.REACT_APP_CURRENCY_SYMBOL}`
          };
        }
        const newPrice = calculateNewPrice(price, appliedCode.discount);
        return {
          title: 'New Price',
          value: {
            crossed: `${price} ${process.env.REACT_APP_CURRENCY_SYMBOL}`,
            active:
              newPrice <= 0
                ? 'FREE'
                : `${newPrice} ${process.env.REACT_APP_CURRENCY_SYMBOL}`
          }
        };
      }
    }
  }, [status, price, appliedCode]);

  return (
    <MarketPageDescBlock
      title={wording.title}
      value={wording.value}
      className={className}
    />
  );
};

export default MarketPageActionHint;
